"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["CASH"] = "cash";
    PaymentType["CARD"] = "card";
    PaymentType["WIRE_TRANSFER"] = "wire_transfer";
    PaymentType["CHEQUE"] = "cheque";
    PaymentType["OTHER"] = "other";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
